@use 'src/globals/main';

pn-tag {
  display: inline-block;
}

pn-tag .pn-tag {
  display: inline-flex;
  flex-direction: row;
  gap: 0.5em;
  justify-content: center;
  align-items: center;

  border-radius: 0.5em;

  /* Default size - Medium */
  padding: 0.5em 1em;
  &[data-icon] {
    padding-left: 0.75em;
  }

  /* Default appearance */
  background-color: rgba(main.$blue200, 0.3);
  color: main.$blue900;
  &[data-dark] {
    background-color: main.$blue200;
  }

  pn-icon .pn-icon-svg path {
    fill: main.$blue900;
  }

  &-label {
    line-height: 1.5em;
    font-weight: 400;
  }

  /* --------------------------------------- SIZES S + L --------------------------------------- */
  /** Extra small tag */
  &[data-xsmall] {
    padding: 0 0.5em;
    .pn-tag-label {
      font-size: 0.875em;
      line-height: 1.715em;
    }
  }
  /** Small tag */
  &[data-small] {
    padding: 0.125em 0.5em;
    .pn-tag-label {
      font-size: 0.875em;
      line-height: 1.715em;
    }
    &[data-icon] {
      padding-left: 0.5em;
    }
  }
  /** Large tag */
  &[data-large] {
    padding: 0.75em 1.25em;
  }
  /* --------------------------------------- /SIZES S + L --------------------------------------- */

  /* --------------------------------------- APPEARANCE --------------------------------------- */
  &[data-appearance='discrete'] {
    background-color: rgba(main.$gray200, 0.3);
    color: main.$gray900;
    &[data-dark] {
      background-color: main.$gray200;
    }

    pn-icon .pn-icon-svg path {
      fill: main.$gray900;
    }
  }

  &[data-appearance='positive'] {
    background-color: rgba(main.$green200, 0.3);
    color: main.$green900;
    &[data-dark] {
      background-color: main.$green200;
    }

    pn-icon .pn-icon-svg path {
      fill: main.$green900;
    }
  }

  &[data-appearance='warning'] {
    background-color: rgba(main.$orange200, 0.3);
    color: main.$orange700;
    &[data-dark] {
      background-color: main.$orange200;
    }

    pn-icon .pn-icon-svg path {
      fill: main.$orange700;
    }
  }

  &[data-appearance='error'] {
    background-color: rgba(main.$coral200, 0.3);
    color: main.$warning;
    &[data-dark] {
      background-color: main.$coral200;
    }

    pn-icon .pn-icon-svg path {
      fill: main.$warning;
    }
  }
  /* --------------------------------------- /APPEARANCE --------------------------------------- */
}
